/**
 * MODAL ENTRY POINT
 *
 * This component can be used to display a modal with custom content and custom
 * buttons. The buttons can have event handlers attached if specified.
 *
 * @version 0.1
 */

import React from 'react';
// import ReactDOM from 'react-dom';
import FocusTrap from 'focus-trap-react';
import Spinner from '../Spinner/Spinner';

class Modal extends React.Component {

    constructor(props) {
        super(props);
        this.handlerEscape = this.handlerEscape.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onClick = this.onClick.bind(this);

        this.state = {
            isModalBusy: false
        }
    }

    componentDidMount() {
        document.body.classList.add('disable-body-scroll');
    }

    componentWillUnmount() {
        document.body.classList.remove('disable-body-scroll');
    }

    handlerEscape(event) {
        if (this.props.closeButtonHandler && (event.key == "Escape" || event.key == "Esc" || event.keyCode == 27))
            this.props.closeButtonHandler();
    }

    closeModal(event) {
        if (this.props.closeButtonHandler && event.target.className === 'app-modal' || event.target.className === 'app-modal__wrapper') {
            this.props.closeButtonHandler();
        }
    }

    onClick(button) {
        if(button.promise) {
            this.setState({
                isModalBusy: true
            });
            button.promise()
                .then(
                    () => {
                        button.click ? button.click() : null;
                        this.setState({
                            isModalBusy: false
                        });
                    }
                )
        } else {
            button.click()
        }
    }

    render() {

        let buttons = [];

        if (this.props.buttons) {
            for (let i = 0; i < this.props.buttons.length; i++) {
                let button = this.props.buttons[i],
                    classes = button.primary ? 'button-primary-sm' : 'button-secondary-sm';

                classes += (button.isDisabled ? ' disabled' : '');

                buttons.push(
                    <button type="button"
                            key={'app-modal-button-' + Math.random() + '-' + i}
                            disabled={this.state.isModalBusy}
                            className={classes}
                            onClick={() => this.onClick(button)}
                            tabIndex={button.tabIndex ? button.tabIndex : null}>
                        {button.text}
                    </button>
                );
            }
        }

        return (
            <FocusTrap className="app-modal" onClick={this.closeModal}>
                <div className="app-modal__wrapper" onKeyDown={this.handlerEscape}>
                    <div className="app-modal__content-box">
                        <div className="app-modal__content">
                            {typeof(this.props.closeButtonHandler) === 'function' ?
                                <button type="button"
                                        disabled={this.state.isModalBusy}
                                        className="la-CloseRemove app-modal__close-button"
                                        onClick={this.props.closeButtonHandler}
                                        tabIndex = "-1">
                                </button> : null}
                            <Spinner isLoading={this.state.isModalBusy}>
                                {this.props.children}
                            </Spinner>
                        </div>
                        {buttons.length > 0 ? <div className="app-modal__buttons">{buttons}</div> : null}
                    </div>
                </div>
            </FocusTrap>
        );

        //TODO: when using modal with portal, move all local styles in it's scss
        // const modalRoot = document.getElementById('modal-root');
        // return ReactDOM.createPortal(
        //     <FocusTrap className="app-modal" onClick={this.closeModal}>
        //         <div className="app-modal__wrapper" onKeyDown={this.handlerEscape}>
        //             <div className="app-modal__content-box">
        //                 <div className="app-modal__content">
        //                     {typeof(this.props.closeButtonHandler) === 'function' ?
        //                         <button type="button"
        //                                 disabled={this.state.isModalBusy}
        //                                 className="la-CloseRemove app-modal__close-button"
        //                                 onClick={this.props.closeButtonHandler}
        //                                 tabIndex = "-1">
        //                         </button> : null}
        //                     <Spinner isLoading={this.state.isModalBusy}>
        //                         {this.props.children}
        //                     </Spinner>
        //                 </div>
        //                 {buttons.length > 0 ? <div className="app-modal__buttons">{buttons}</div> : null}
        //             </div>
        //         </div>
        //     </FocusTrap>,
        //     modalRoot
        // );
    }

}

export default Modal;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Modal/Modal.index.jsx